import React, {
  useEffect,
  useState,
} from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useParams } from "react-router";

import { useLoadingContext } from "../../context/roomContext";

import "../styles/loadingStyles.scss";

type Props = {
  content: React.ReactNode;
};

const LoadingLayer = ({ content }: Props) => {
  const { cid } = useParams();

  const {
    activateTimer,
    setActivateTimer,
  } = useLoadingContext();

  const [showRefresh, setShowRefresh] =
    useState(false);

  useEffect(() => {
    setShowRefresh(false);

    const timer = window.setTimeout(() => {
      setShowRefresh(true);
    }, 10_000);

    return () => {
      window.clearTimeout(timer);
    };
  }, [activateTimer]);

  const onRefresh = () => {
    setActivateTimer(false);
    window.location.reload();
  };

  return (
    <div className="loading-layer">
      <LoadingOutlined
        style={{
          fontSize: "86px",
          color: "#fff",
        }}
      />

      {showRefresh && cid ? (
        <>
          <p
            className="loading-text"
            style={{ paddingBottom: 5 }}
          >
            This seems to be taking a while...
          </p>

          <Button
            type="primary"
            size="large"
            onClick={onRefresh}
          >
            Refresh
          </Button>
        </>
      ) : (
        <p className="loading-text">
          {content}
        </p>
      )}
    </div>
  );
};

export default LoadingLayer;